<template>
    <div id="app" class="app">
        <navbar v-if="showHeaderAndFooter"></navbar>
        <router-view></router-view>
        <bottom v-if="showHeaderAndFooter"></bottom>
    </div>
</template>

<script>
import navbar from './components/navbar';
import bottom from './components/bottom';
export default {
    created(){
        
    },
    computed:{
        showHeaderAndFooter(){
            var path = this.$router.history.current.path;
            return !path.startsWith('/admin');
        }
    },
    mounted(){
        var locale = window.localStorage.getItem('locale');
        if(locale != null){
            this.$i18n.locale = locale;
        }

        console.log(this.$router.history.current.path);
    },
    components: {
       navbar,
       bottom
    },
};
</script>

<style>
body{
    margin:0px;
    padding:0px;
}

a{
    color:#666;
}

a:hover{
    color:#526193 !important;
    text-decoration:none;
}

.dropdown-item.active, .dropdown-item:active{
    background:#526193 !important;
    color:white !important;
}

.form-control{
    box-shadow:0px 0px 8px #e5e5e5 !important;
}

.form-control:focus{
    box-shadow:0px 0px 15px #e5e5e5 !important;
    border:1px solid #ced4da !important;
}
</style>



// WEBPACK FOOTER //
// App.vue?12298f74